import { put } from 'redux-saga/effects'
import { commonError } from "../../src/helper/constant"
import {
    ETFTOKEN_RESPONSE, ETFTOKEN_RESPONSE_FAIL, ETFTRANSACTIONID_RESPONSE, ETFTRANSACTIONID_RESPONSE_FAIL
    , GETTICKERCODE_RESPONSE, GETTICKERCODE_RESPONSE_FAIL
} from '../redux/types/etfTransaction';
import { endpoints } from '../services/endpoints';
import triggerApi from "../services/triggerAPI";

let call = new triggerApi();

export function* createETFToken({ payload, resolve }) {
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.etfTransaction.createETFToken);
        if (data.success) {
            yield put({ type: ETFTOKEN_RESPONSE, payload: data })
            resolve && resolve(data)
        }
        else {
            resolve && resolve(data)
            yield put({ type: ETFTOKEN_RESPONSE_FAIL, payload: data })
        }
    } catch (e) {
        yield put({ type: ETFTOKEN_RESPONSE_FAIL, payload: e })
    }
}

export function* CreateTransactionID({ payload, resolve }) {
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.etfTransaction.CreateTransactionID);
        if (data.success) {
            yield put({ type: ETFTRANSACTIONID_RESPONSE, payload: data })
            resolve && resolve(data)
        }
        else {
            resolve && resolve(data)
            yield put({ type: ETFTRANSACTIONID_RESPONSE_FAIL, payload: data })
        }
    } catch (e) {
        yield put({ type: ETFTRANSACTIONID_RESPONSE_FAIL, payload: e })
    }
}

export function* GetTickerCode({ payload, resolve }) {
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.etfTransaction.GetTickerCode);
        if (data.success) {
            yield put({ type: GETTICKERCODE_RESPONSE, payload: data })
            resolve && resolve(data)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GETTICKERCODE_RESPONSE_FAIL, payload: data })
        }
    } catch (e) {
        yield put({ type: GETTICKERCODE_RESPONSE_FAIL, payload: e })
    }
}